import { FileIconType } from './file-icon/file-icon.component';

export interface DocumentItem {
  id: string;
  name: string;
  type: 'folder' | 'document' | 'file';
  updatedDate: string;
  updatedBy: string;
  fileCount?: number;
  webUrl?: string | null;
  mimeType?: string | null;
  fileExtension?: string;
  title?: string;
  icon?: string;
  size?: string;
}

export const MIME_TYPE_ICONS: Record<string, FileIconType> = {
  'application/pdf': 'pdf',
  'application/vnd.ms-excel': 'xls',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
  'application/msword': 'doc',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx'
};

export const EXT_ICONS: Record<string, FileIconType> = {
  pdf: 'pdf',
  xls: 'xls',
  xlsx: 'xlsx',
  doc: 'doc',
  docx: 'docx',
  csv: 'csv'
};
